<template>
    <div class="input-block">
        <label class="label">{{ labelName }}</label>
        <basic-select
            class="search-input"
            :options="options"
            :selectedOption="value ? value : undefined"
            v-model="value"
            @select="valueSelected"
            :placeholder="placeholder"
        />
        <div class="error-message" v-if="error">{{ error }}</div>
    </div>
</template>

<script>
import { BasicSelect } from 'vue-search-select'

export default {
    name: 'SelectField',
    data() {
        return {
            value: null,
            options: [],
        }
    },
    props: ['labelName', 'initialValue', 'optionsArray', 'placeholder', 'error'],
    watch: {
        $props: {
            handler() {
                this.checkProps()
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.checkProps()
    },
    methods: {
        checkProps() {
            if (this.initialValue) {
                this.value = this.initialValue
            }
            if (this.optionsArray && this.optionsArray.length) {
                this.options = this.optionsArray
            }
        },
        valueSelected(val) {
            this.value = val
            this.$emit('input', val)
        },
    },
    components: {
        BasicSelect,
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/global-styles';

.input-block {
    padding: 10px 20px;
    flex-basis: 25%;
    position: relative;

    &:hover,
    &:active {
        background: rgba(192, 192, 201, 0.12) 0% 0% no-repeat padding-box;
        border-radius: 6px;
    }

    .label {
        font-family: 'Gilroy-Regular', sans-serif;
        font-size: 12px;
        line-height: 14px;
        text-align: left;
        color: $mainTextBlueColor;
    }

    >>> .search-input.ui.selection.dropdown {
        background: transparent;
        border: none;
        color: $mainTextBlueColor;
        padding: 10px 10px 10px 0;
        position: relative;

        &:hover {
            box-shadow: none;
            border: none;
        }

        &.active {
            box-shadow: none;
            border: none;
            .dropdown.icon {
                color: $mainTextBlueColor;
                content: '';

                &:before {
                    content: '';
                }
            }
        }

        &.visible {
            .dropdown.icon {
                background-image: url('~@/assets/main_images/inverse-top-bottom-icon.png');
            }
        }

        .dropdown.icon {
            color: $mainTextBlueColor;
            content: '';
            position: absolute;
            top: 60%;
            transform: translateY(-50%);
            line-height: 10px;
            font-size: 6.5px;
            background-image: url('~@/assets/main_images/top-bottom-icon.png');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;

            &:before {
                content: '';
            }

            &:after {
                content: '';
            }
        }

        .selection.dropdown > input.search {
            opacity: 0;
            width: 0;
            pointer-events: none;
        }

        input.search {
            opacity: 0;
            width: 0;
            pointer-events: none;
            cursor: pointer;
            outline: none;
        }

        .ui.search.selection.dropdown > span.sizer {
            background: transparent;
            border: none;
            font-family: 'Gilroy-Regular', sans-serif;
            font-size: 18px;
            line-height: 22px;
            padding: 0;
            text-align: left;
            color: $mainTextBlueColor;
        }

        .text {
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 18px;
            line-height: 22px;
            text-align: left;
            color: $mainTextBlueColor;
            cursor: pointer;

            &.default {
                font-family: 'Gilroy-SemiBold', sans-serif;
                font-size: 18px;
                line-height: 22px;
                text-align: left;
                color: $mainTextBlueColor;
                opacity: 1;
            }
        }

        .menu {
            color: $blueTextFixedColor;
            padding: 10px 0;
            margin-left: -10px;
            margin-top: -5px;
            border: none;
            border-radius: 6px;
            background: #f5f5f6;
            outline: none;
            width: 100%;

            &:hover {
                cursor: pointer;
            }

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.1);
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: rgba(255, 255, 255, 0.2);
            }

            .item {
                font-family: 'Gilroy-Regular', sans-serif;
                font-size: 12px;
                line-height: 20px;
                text-align: left;
                color: $mainTextBlueColor;
                border: none;

                &:hover {
                    background-color: rgba(1, 1, 83, 0.05);
                }
            }
        }
    }

    .error-message {
        font-family: 'Gilroy-Regular', sans-serif;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0.4px;
        color: $mainErrorColor;
        position: absolute;
        bottom: 0;
        left: 20px;
        animation-name: errorHandle;
        animation-duration: 0.5s;
    }

    @keyframes errorHandle {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
}

@media (max-width: 768px) {
    .input-block {
        max-width: unset;
        padding: 10px 20px;
        flex-basis: unset;
        width: 100%;

        .label {
            font-size: 14px;
            line-height: 17px;
        }

        >>> .search-input.ui.selection.dropdown {
            width: 100%;
            max-width: unset;

            .ui.search.selection.dropdown > span.sizer {
                font-size: 16px;
                line-height: 20px;
            }

            .text {
                font-size: 16px;
                line-height: 20px;

                &.default {
                    font-size: 16px;
                    line-height: 20px;
                }
            }
        }

        .error-message {
            left: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/forms_entities/form-fields/select-field.vue